import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
    cn,
} from '@repo/shadcn';
// import { useState } from 'react';
import 'react-calendar/dist/Calendar.css';
import { DatePicker, DatePickerProps } from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import { FieldValues, Path, useFormContext } from 'react-hook-form';

// type DateValue = Date | null;
// type DatePickerValue = DateValue | [DateValue, DateValue];

type DatePickerFieldProps<T extends FieldValues = FieldValues> =
    DatePickerProps & {
        name: Path<T>;
        label?: string;
        required?: boolean;
        className?: string;
    };

export const DatePickerField = <T extends FieldValues = FieldValues>({
    name,
    label,
    required,
    className,
    ...props
}: DatePickerFieldProps<T>) => {
    // const [value, onChange] = useState<DatePickerValue>(new Date());

    const { control } = useFormContext<T>();

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={cn(className)}>
                    {label && (
                        <FormLabel htmlFor={name}>
                            <span>{label}</span>
                            {required && (
                                <span className="ml-1 text-red-500">*</span>
                            )}
                        </FormLabel>
                    )}
                    <FormControl>
                        <div className="relative flex items-center gap-2">
                            <DatePicker
                                onChange={(date) => field.onChange(date)}
                                value={field.value}
                                minDate={new Date()}
                                format="dd-MM-y"
                                className={'w-full rounded-md'}
                                {...props}
                            />
                        </div>
                    </FormControl>

                    <FormMessage className="line-clamp-1 text-xs" />
                </FormItem>
            )}
        />
    );

    // return (
    //     <div>
    //         <DatePicker onChange={onChange} value={value} />
    //     </div>
    // );
};

DatePickerField.displayName = 'DatePickerField';
